import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import stl from "@/pages/landingPages/LandingPageRoot.module.css";
import SellTradeLanding from "@/pages/sell-trade-v2/sell-trade/SellTradeLanding";
import { useTranslation } from "@i18n";
import useIsWebView from "@hooks/useIsWebview";
import useWebView from "@hooks/useWebview";
import useHelpers from "@hooks/useHelpers";
import SyarahLogoLottie from "@/components/SyarahLogoLottie/SyarahLogoLottie";
var SellTradePage = function SellTradePage() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isWebView = useIsWebView();
  var webview = useWebView();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var backClicked = function backClicked() {
    webview.closeScreen()["catch"](function () {
      navigateTo("/");
    });
  };
  var mobileHeader = function mobileHeader() {
    if (isWebView && __IS_SSR__) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center bg-white py-2 px-4",
      style: {
        borderBottom: "1px solid #E9E9E9"
      }
    }, /*#__PURE__*/React.createElement("div", {
      onClick: backClicked,
      className: "cursor-pointer mx-4"
    }, /*#__PURE__*/React.createElement(SyarahLogoLottie, {
      className: "object-fit w-16 h-12",
      alt: "logo"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex-1 mx-14 text-black font-bold text-base"
    }, t("sell_car_2", {
      ns: "web_common"
    }))));
  };
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    hasNavBar: true,
    authenticationMsg: true,
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    loading: true,
    mainClass: stl.mainFinancingClass,
    hideHeaderOnmobile: true,
    mobileHasTitle: t("sell_car_2", {
      ns: "web_common"
    }),
    custommobileHeader: mobileHeader()
  }, /*#__PURE__*/React.createElement(SellTradeLanding, null));
};
export default SellTradePage;